import type { Analytics } from 'src/middlewares/createAnalyticsMiddleware';
import type { ConfirmedActionName } from 'src/modules/analytics/types';
import {
  type YearsOfExperienceAction,
  Actions as YearsOfExperienceActions,
} from 'src/modules/analytics/yearsOfExperience/actionCreators';

import { instrumentAnalytics } from '../analyticsMiddlewareUtils';

export const createYearsOfExperienceAnalyticsMiddleware = (
  analytics: Analytics,
) =>
  instrumentAnalytics(analytics) &&
  (() =>
    (next: (action: YearsOfExperienceAction) => void) =>
    (action: YearsOfExperienceAction) => {
      switch (action.type) {
        case YearsOfExperienceActions.YEARS_OF_EXPERIENCE_UPDATE: {
          const { updateCard } = analytics;

          const { actionName, userIsNewToWorkforce } = action.payload;
          updateCard({
            currentPageSection: 'years of experience',
            actionName: actionName as ConfirmedActionName,
            actionOrigin: 'main card',
            customProps: {
              userIsNewToWorkforce,
            },
          });
          break;
        }
        default: {
          break;
        }
      }
      return next(action);
    });
